// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyDR_aAoRDZyRgxQsJ4Nl1_GqAYZPMgz5_A",
  authDomain: "bounch.firebaseapp.com",
  databaseURL: "https://bounch.firebaseio.com",
  projectId: "bounch",
  storageBucket: "bounch.appspot.com",
  messagingSenderId: "766442145973",
  appId: "1:766442145973:web:0bd930e842ca92a7af56fc",
  measurementId: "G-BLFM0G0Z77",
};
